module.exports = __webpack_public_path__ + "static/item-1-6c0e9b6f01689a50ec9c1a576d799d55.png";